import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import ArchivosAdjuntosDropzone from "common/components/ArchivosAdjuntosDropzone"
import { FormikDocumentsProps } from "features/Crear/pages/FormCreacionDocumento/CreacionDocumento"
import { ArrayHelpers, FieldArray } from "formik"
import { useTranslation } from "react-i18next"

const CardAdjuntarArchivoDocumentoSetting = ({
  values,
  setFieldValue,
}: FormikDocumentsProps) => {
  const { t } = useTranslation()

  const encodeImageToBase64 = async (
    file: File
  ): Promise<string | ArrayBuffer | null> => {
    const reader = new FileReader()

    return new Promise((resolve, reject) => {
      reader.onload = () => {
        const result = reader.result as string
        const base64String = result.split(",")[1]
        resolve(base64String)
      }
      reader.onerror = (error) => reject(error)
      reader.readAsDataURL(file)
    })
  }

  const handleUpload = async (newFiles: File[]) => {
    const newFilterFormat = await Promise.all(
      newFiles.map(async (file: File) => ({
        archivo: file,
        base64: await encodeImageToBase64(file),
      }))
    )

    setFieldValue("archivosAdjuntos", newFilterFormat)
  }

  const calculateFileSizeInKB = (bytes: number) => {
    const KB = 1024
    const sizeInKB = bytes / KB
    return Math.round(sizeInKB / 10) * 10
  }

  return (
    <div className='tw-w-full tw-flex tw-flex-col'>
      <p className='tw-mb-2 tw-text-lg tw-font-medium'>
        {t("crear.facturaRec.settings.attachmentsLabel")}
      </p>
      <div className='tw-mt-3 hover:!tw-shadow-md'>
        <ArchivosAdjuntosDropzone
          handleUpload={handleUpload}
          maxFiles={undefined}
          multiple={undefined}
        />
      </div>
      <div className='mt-1'>
        <FieldArray name='archivosAdjuntos'>
          {({ remove }: ArrayHelpers) => (
            <>
              {values.archivosAdjuntos?.map(
                (
                  item: {
                    archivo: File
                    base64: string
                  },
                  index: number
                ) => {
                  return (
                    <div
                      key={`${item?.archivo?.name}`}
                      className='tw-min-h-20 tw-w-full tw-shadow tw-flex tw-flex-row tw-items-center tw-justify-between tw-px-4 tw-py-2 tw-mt-4 tw-rounded'
                    >
                      <div className='tw-w-12 tw-h-full tw-flex tw-justify-center tw-items-center'>
                        <FontAwesomeIcon
                          icon={["fal", "file"]}
                          className='tw-text-secondary'
                        />
                      </div>
                      <div className='tw-flex tw-flex-col tw-flex-grow tw-mx-4 tw-overflow-hidden'>
                        <span className='tw-w-full tw-break-words'>
                          {item?.archivo?.name}
                        </span>
                        <span className='tw-text-sm tw-text-neutral-25'>
                          {calculateFileSizeInKB(item?.archivo?.size)} KB
                        </span>
                      </div>
                      <div
                        className='tw-w-12 tw-h-full tw-flex tw-justify-center tw-items-center tw-cursor-pointer'
                        onClick={() => remove(index)}
                      >
                        <FontAwesomeIcon
                          icon={["fal", "trash"]}
                          className='tw-text-danger'
                        />
                      </div>
                    </div>
                  )
                }
              )}
            </>
          )}
        </FieldArray>
      </div>
    </div>
  )
}

export default CardAdjuntarArchivoDocumentoSetting
